/** 拨号状态 **/
<template>
  <div class="home data-panel-home dial-status-home">
    <Layout type="HOME" pageTitle="标准节点" titleSrc="/menu/dialStatus.png">
      <!-- 拨号状态 -->
      <BasiceLayout v-if="diskList && diskList.length" title="设备坏盘信息" class="bonus-code-layout margin-top-20">
        <div
            v-for="item in diskList"
            class="item-list"
        >
          <div class="first-info">
            <div class="first-wrap">
              <span class="host-name margin-bottom-20">主机名：</span>
              <span class="host-info">{{item.host}}</span>
            </div>
          </div>
          <div class="second-info" v-for="diskItem in item.value">
            <div>name：{{diskItem.name}}</div>
            <div>sn：{{diskItem.sn}}</div>
          </div>
        </div>
      </BasiceLayout>
      <BasiceLayout v-else title="设备坏盘信息" class="bonus-code-layout margin-top-20">
         <p style="text-align: center;">暂无数据</p>
      </BasiceLayout>
    </Layout>
  </div>
</template>

<script>
  import Header from "@/components/Header.vue";
  import { mapActions } from "vuex";
  import Layout from "@/components/DatePanel/Layout.vue";
  import BasiceLayout from "@/components/Common/BasicLayout.vue";
  import { Message } from "element-ui";

  export default {
    components: {
      Header,
      Layout,
      BasiceLayout
    },
    data() {
      return {
        diskList: [],
      };
    },
    methods: {
      ...mapActions([
          'getAbnormalDisk',
      ]),
      async queryAbnormalDisk() {
        const res = await this.getAbnormalDisk();
        if(res.code == 200) {
            this.diskList = res.data;
        } else {
            this.diskList = [];
        }
      }
    },
    created() {
        this.queryAbnormalDisk();
    },
  }
</script>

<style scoped lang="stylus">
  .basic-layout-wrap {
    background: #fff;
    border: 1px solid #e3e3e7;
    position: relative;
  }

  .dial-status-home .item-list {
    border-bottom: 1px solid #ddd;
    margin: 20px;
  }

  .dial-status-home .second-info {
    display: flex;
    margin: 20px;

    // padding: 0 20px;
    div {
      width: 33.33%;
    }
  }

  .dial-status-home .first-info {
    display: flex;
    margin: 20px;

    .first-wrap {
      // margin: 20px;
      // padding: 0 20px;
    }
  }

  .dial-left-wrap,
  .dial-right-wrap {
    width: 50%;
    text-align: center;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .host-info {
    color: #65686a;
  }

  .right-circle {
    width: 10px;
    height: 10px;
    display: inline-block;
    border-radius: 5px;
    background-color: #1add75;
    margin-right: 10px;
  }

  .error-circle {
    width: 10px;
    height: 10px;
    display: inline-block;
    border-radius: 5px;
    background-color: red;
    margin-right: 10px;
  }

  .disabledBtn {
    width: 90px;
    height: 35px;
    text-align: center;
    border-radius: 0;
    font-weight: 400;
    font-style: PingFangSC-Regular;
    padding: 0;
  }

  .disabledTxt {
    color: #c3c3c3;
    cursor: not-allowed;
  }

  .dial-errormsg {
    width: 70%;
    padding: 0 30px;
  }

  .title-undial {
    text-align: center;
    margin: 70px 0 10px 0;
    font-size: 16px;
    font-weight: bold;
  }

  .title-unnormal {
    margin: 10px 0 10px 0;
  }
</style>